import { Link } from "react-router-dom";
import { SplitLines, Reveal } from "@/components/fx/Reveal";
import { ROLE_LINKS } from "@/content/seo";

const GROUPS = [
  { name: "Operativi", roles: ["operai e addetti produzione", "magazzinieri", "autisti", "tecnici e manutentori", "estetiste", "personale sala e cucina", "addetti vendita"] },
  { name: "Commerciali", roles: ["commerciali e agenti", "key account", "inside sales", "area manager"] },
  { name: "Impiegati", roles: ["receptionist", "impiegati amministrativi", "contabili", "back office"] },
  { name: "Manageriali", roles: ["capi reparto", "team leader", "coordinatori", "manager e direttori"] },
];
const flat = (gs) => gs.flatMap((g) => g.roles.map((r) => ({ r, g: g.name })));
const ROW1 = flat(GROUPS.slice(0, 2));
const ROW2 = flat(GROUPS.slice(2));

const Row = ({ items, reverse, dur, offset }) => (
  <div className="rl-marquee-wrap overflow-hidden py-2">
    <ul className={`rl-marquee ${reverse ? "reverse" : ""}`} style={{ "--dur": dur }}>
      {[...items, ...items].map((it, i) => (
        <li
          key={i}
          aria-hidden={i >= items.length}
          className="mr-3 inline-flex shrink-0 items-center gap-3 rounded-full border border-[#E7E5DF] bg-white px-6 py-4 font-display text-lg tracking-[-0.01em] text-[#2C2C2A] transition-colors duration-300 hover:border-[#0F6E56] hover:bg-[#BCE3D6]/40 sm:text-2xl lg:px-8 lg:py-5"
          data-testid={i < items.length ? `ruolo-chip-${offset + i}` : undefined}
        >
          <Link to={`/ruoli/${ROLE_LINKS[it.r]}`} tabIndex={i >= items.length ? -1 : undefined} className="inline-flex items-center gap-3">
            <span className="h-2 w-2 rounded-full bg-[#0F6E56]" />
            {it.r}
            <span className="font-mono-data text-[10.5px] uppercase tracking-[0.14em] text-[#6B6961]">{it.g}</span>
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Ruoli = () => (
  <section id="ruoli" className="rl-section relative overflow-hidden py-28 lg:py-40" data-testid="ruoli-section">
    <div className="rl-container grid gap-10 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <p className="rl-eyebrow text-[#0F6E56]">Ruoli</p>
        <SplitLines className="rl-h2 mt-6" lines={["Dall'operaio al direttore.", <span key="s" className="text-[#0F6E56]">Stesso metodo.</span>]} data-testid="ruoli-title" />
      </div>
      <Reveal className="rl-fade lg:col-span-5 lg:pt-16">
        <p className="text-lg leading-relaxed text-[#2C2C2A]/85" data-testid="ruoli-text">
          Un magazziniere sbagliato può fermare la produzione quanto un manager sbagliato. Per questo ogni ruolo passa dallo stesso processo.
        </p>
      </Reveal>
    </div>
    <div className="mt-16 space-y-3 lg:mt-24" data-testid="ruoli-marquee">
      <Row items={ROW1} dur="70s" offset={0} />
      <Row items={ROW2} reverse dur="60s" offset={ROW1.length} />
    </div>
    <div className="rl-container mt-12">
      <ul className="grid grid-cols-2 gap-3 md:grid-cols-4" data-testid="ruoli-groups">
        {GROUPS.map((g, i) => (
          <li key={g.name} className="rl-card flex items-center justify-between px-5 py-4" data-testid={`ruoli-group-${i}`}>
            <span className="font-display text-[17px]">{g.name}</span>
            <span className="font-mono-data text-[13px] text-[#0F6E56]">{String(g.roles.length).padStart(2, "0")}</span>
          </li>
        ))}
      </ul>
      <nav aria-label="Approfondisci" className="mt-8 flex flex-wrap items-center gap-2" data-testid="ruoli-approfondisci">
        <span className="mr-2 font-mono-data text-[12px] uppercase tracking-[0.14em] text-[#6B6961]">Approfondisci</span>
        {[["/ruoli", "Tutti i ruoli"], ["/settori", "Settori"], ["/settori/logistica-trasporti", "Logistica"], ["/settori/estetica-benessere", "Estetica"], ["/settori/industria-produzione", "Produzione"], ["/guide", "Guide per assumere"]].map(([to, l]) => (
          <Link key={to} to={to} className="inline-flex min-h-[44px] items-center rounded-full border border-[#E7E5DF] bg-white px-4 text-[14px] hover:border-[#0F6E56] hover:text-[#0F6E56]">{l}</Link>
        ))}
      </nav>
    </div>
  </section>
);
